export enum SliceCallState {
  'idle',
  'pending',
  'succeeded',
  'failed',
}
